/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.seo.ts
 *
 * Réglages du référencement (section « seo. » de Réglages, migration V155),
 * lus par le serveur (api/_lib/seo.php). Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-10-08
 */
export const messagesSeoFr: Record<string, string> = {
  'settingsAdmin.section.seo': 'Référencement (Google)',
  'settingsAdmin.seo.google_site_verification.help':
    'Google Search Console, « Ajouter une propriété », « Préfixe de l’URL », méthode « Balise HTML » : collez ici le code donné par Google (ou la balise entière), enregistrez, puis cliquez sur « Valider » dans Search Console. Vide : aucune balise.',
  'settingsAdmin.seo.entree_gratuite.help':
    'Activé : les moteurs de recherche peuvent présenter l’événement comme gratuit. À n’activer que si l’entrée l’est vraiment.',
  'settingsAdmin.seo.description.help':
    'Texte affiché sous le titre de l’accueil dans les résultats de recherche, 160 caractères au plus. Vide : composé automatiquement à partir du nom, de l’accroche, de la date et du lieu de l’événement.',
};
